module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAD5x1oQdwjzAAAAAXRSTlMAQObYZgAAACRJREFUGNNjYCAe/P//nxlBHWBgpgJ1+P9hJIr2+lApVB8RCwBwlCixbkW3kgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/zjlx@2x.png
// module id = LzBR
// module chunks = 0